// React
import * as React from 'react';

//Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

import styled from 'styled-components';

// React Router
import { Redirect, withRouter } from "react-router-dom";

// Stripe HOC
import { injectStripe } from 'react-stripe-elements';

// Vendor Libraries
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { LoadingOverlay, Loader } from 'react-overlay-loader';
import ActionShoppingCart from 'material-ui/svg-icons/action/shopping-cart';
import CircularProgress from 'material-ui/CircularProgress';
import Select from 'react-select';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ProgressSpinner from './ProgressSpinner';

// Form Components
import { HiddenLabel } from '../StyledComponents/HiddenLabel';
import { FormIcon } from '../FormIcon';
import { ActionButton } from '../Buttons/ActionButton';
import { BackButton } from '../Buttons/BackButton';
import { CancelButton } from '../Buttons/CancelButton';
import { FormGroup } from '../StyledComponents/FormGroup';
import { TextFieldAdapter } from '../TextFieldAdapter';
import { ErrorMessage } from '../ErrorMessage';
import CardSection from './CardSection';

// Form Validation Utilities
import { required, composeValidators, isValidName, isNum } from '../validation';

// CUSTOM UTILS
import { getUserTimezone } from '../../../utils/timezoneUtils';
import { constants, photoURLs } from '../../../constants/index';

class StripePaymentForm extends React.Component {
    state = {
        cardFormComplete: null,
        cardFormEmpty: null,
        cardFormError: null,
        cardFormValue: null,
        submitted: false,
        successRedirect: false,
        selectedProvince: null
    }
    
    handleSubmit = (values) => {
        // console.log('HEY YOU SUBMITTED!', values);
        this.setState({
            submitted: true,
        });
        this.props.stripe.createToken({type: 'card', name: values.name})
            .then(({token}) => {
                // console.log('MAKING PAYMENT WITH CREDIT CARD');
                this.props.makePayment({
                    client: this.props.userId,
                    companyId: this.props.booking.service.company,
                    providerId: this.props.booking.service.provider,
                    percentTax: this.state.selectedProvince && this.state.selectedProvince.value,
                    serviceId: this.props.booking.service._id,
                    servicePeriod: {
                        startDate: this.props.booking.date,
                        startTime: this.props.booking.time,
                        duration: this.props.booking.service.duration,
                        userTimezone: getUserTimezone(),
                    },
                    token: token,
            })
            .then((confirmationData) => {
                // console.log('PAYMENT DONE NOW ONTO BOOKING IN FRONT END');
                this.props.notifyUser({
                    duration: 4000,
                    message: 'Payment has succeeded. Now booking your consult...',
                    textColor: 'white',
                    visible: true,
                })
                if (confirmationData.charge.status === 'succeeded') {
                    // console.log('SUCCESSFUL CHARGE');
                    // console.log('ACTIVE PERIOD', confirmationData.purchasedActivePeriod);
                    
                    this.props.handleConfirmBooking(this.props.formValues, confirmationData.purchasedActivePeriod, () => { return null });
                    // REDIRECT RIGHT AFTER PAYMENT TO MAKE WAIT SHORTER
                    this.setState({
                        successRedirect: true
                    });
                } else {
                    // console.log('SHOW ERROR TO THE USER THE PAYMENT HAS FAILED');
                    alert('Payment failed. You were not charged. Please try again.', JSON.stringify(confirmationData));
                    // SHOW SERVER ERRORS HERE, IF A PAYMENT SERVER ERROR EXISTS this.props.getPaymentServerError();
                }
            })
            .catch(console.log) 
        });
    }
    
    handleCreditSubmit = (values) => {
        this.setState({
            submitted: true,
        });

        this.props.makePayment({
            client: this.props.userId,
            companyId: this.props.booking.service.company,
            percentTax: this.state.selectedProvince && this.state.selectedProvince.value,
            providerId: this.props.booking.service.provider,
            serviceId: this.props.booking.service._id,
            servicePeriod: {
                startDate: this.props.booking.date,
                startTime: this.props.booking.time,
                duration: this.props.booking.service.duration,
                userTimezone: getUserTimezone(),
            },
            token: {
                id: 'empty'
            },
        })
        .then((confirmationData) => {
            this.props.notifyUser({
                duration: 4000,
                message: 'Payment has succeeded. Now booking your consult...',
                textColor: 'white',
                visible: true,
            })
            if (confirmationData.isComplete === true) {
                // console.log('CREDIT PAYMENT SUCCESS');
                this.props.handleConfirmBooking(this.props.formValues, confirmationData.purchasedActivePeriod, () => { return null });
                // REDIRECT RIGHT AFTER PAYMENT TO MAKE WAIT SHORTER
                this.setState({
                    successRedirect: true
                });
                // this.props.handleConfirmBooking(this.props.formValues, () => {});
                // console.log('REDIRECTING USER TO SERVICE MODULES @ CALLBACK FROM HANDLE CONFIRMBOOKING');
                // REDIRECT RIGHT AFTER PAYMENT SUCCESS TO SHORTEN WAIT TIME
            } else {
                // console.log('SHOW ERROR TO THE USER THE PAYMENT HAS FAILED');
                alert('Payment failed. You were not charged. Please try again.', JSON.stringify(confirmationData));
                // SHOW SERVER ERRORS HERE, IF A PAYMENT SERVER ERROR EXISTS this.props.getPaymentServerError();
                // REDIRECT TO PURCHASE PAGE FOR THIS SERVICE
            }
        })
        .catch(console.log)
    }
    
    componentWillUnmount(){
        this.props.handleClose();
    }

    handleSelectProvince = (selectedProvince) => {
        console.log('VALUE OF SELECT', selectedProvince);
        this.setState({
            selectedProvince
        }, ()=> {
            this.props.onSetPercentTax((this.state.selectedProvince) ? this.state.selectedProvince.value : null)
            if (!this.state.selectedProvince) {
                this.setState({
                    provinceSelectTouched: true
                });
            }
            console.log('changing percent tax');
        })
        
    }

    render() {
        const SelectStyles = styled.div`
            .Select-menu {
                display: flex;
                flex-direction: column;
                width: 100%;
            }
            .Select-option {
                display: block;
            }

            .Select-input {
                width: 100px;
            }
            .Select-arrow-zone {
                padding-top: 4px;
                padding-right: 10px;
            }
            .Select-clear {
                padding-top: 7px;
                padding-right: 4px;
            }
            
            /* DropDown Styles */
            .Selet-menu-outer > div{
                width: 100px;
            }
        `;

        const SelectFieldAdapter = ({ input, meta: {touched, error}, ...rest }) => (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <SelectStyles>
                    <Select 
                        {...input} 
                        {...rest} 
                        searchable 
                        value={ this.state.selectedProvince }
                        onChange={this.handleSelectProvince}
                        selectedValue={this.state.selectedProvince}
                    />
                </SelectStyles>
                <div style={{ display: (this.state.provinceSelectTouched && !this.state.selectedProvince) ? 'block' : 'none', marginBottom: -20 }}>
                    <div style={{'fontSize':'12px','color':'rgb(244, 67, 54)'}}>Required</div>
                </div>
            </div>    
        );
        
        const taxByProvince = [ 
            { value: 15, label: 'NL' },
            { value: 15, label: 'PE' },
            { value: 15, label: 'NS' },
            { value: 15, label: 'NB' },
            { value: 14.975, label: 'QC' },
            { value: 13, label: 'ON' },
            { value: 13, label: 'MB' },
            { value: 11, label: 'SK' },
            { value: 5, label: 'AB' },
            { value: 12, label: 'BC' },
            { value: 5, label: 'YT' },
            { value: 5, label: 'NT' },
            { value: 5, label: 'NU' },
        ];

        if (this.state.successRedirect) {
            // REFRESH CHANNEL
            this.props.getMessageThread(this.props.userData, this.props.booking.service, (threadKey) => {
				// console.log('GOT CHANNEL @ TOOLBAR SERVICE SELECT', threadKey, 'SERVICE:', this.props.booking.service._id);
            })
            
            // Refresh list of users service providers
            // this.props.getClientData(this.props.userId, ()=>{
            //     this.props.filterServicesByStatus(this.props.userId);
            // });
                this.props.setSelectedService(this.props.booking.service); //temp
                // this.props.getDBServices(); //temp
                // this.props.getDBProviders(); //temp
                
                // This must be called to update credits after payment.
                this.props.getClientData(this.props.userId);
                
                this.props.history.push(`/service/modules/${this.props.booking.service._id}/awaiting`)
                this.props.updateLocation(`/service/modules/${this.props.booking.service._id}/awaiting`);
                // window.location.reload(); // temp fix for new services not appearing
        }
        
        if (this.props.cost && !this.state.successRedirect) {
            return (
                <div style={ styles.paymentFormContainerStyles }>
                    { this.state.submitted &&
                        <ProgressSpinner 
                            loadingText="PROCESSING..." 
                            message="(You will be redirected shortly. Please do not leave or close this window.)" 
                        />
                    }
                    <div style={{ flex: 1 }} >
                        <Form
                            onSubmit={this.handleSubmit}
                            initialValues={null}
                            validate={ 
                                values => {
                                    const errors = {};
                                    
                                    if (!values.province) {
                                        errors.province = "Required";
                                    }

                                    return errors;
                                }
                            }
                            render={({ handleSubmit, meta, reset, submitting, pristine, values, invalid }) => {
                                return (
                                    <div>
                                        <form id="paymentForm" onSubmit={handleSubmit}>
                                            <FormGroup stack>
                                                <label> Full Name (As it appears on Your card.) </label>
                                                <div>
                                                    <FormIcon name="user" color="#9e9e9e" size={16}/>
                                                    <Field
                                                        name="name"
                                                        component={TextFieldAdapter}
                                                        type="text"
                                                        placeholder="Full Name"
                                                        validate={composeValidators(required, isValidName)}
                                                    />
                                                </div>
                                            </FormGroup>

                                            <FormGroup stack>
                                                <label> Province</label>
                                                <div style={{ width: '100%' }}>
                                                    <FormIcon name="map-marker-alt" size={16} color="#9e9e9e" />
                                                    <Field
                                                        style={{ width: 135 }}
                                                        name="province"
                                                        component={SelectFieldAdapter}
                                                        options={taxByProvince}
                                                        validate={required}
                                                    />
                                                </div>
                                            </FormGroup>
                                            
                                            <CardSection
                                                render = {
                                                    ({error, complete, value, empty, updated}, renderCard) => {
                                                        if(updated === false) {
                                                            this.setState({
                                                                cardFormError: error,
                                                                cardFormComplete: complete,
                                                                cardFormValue: value,
                                                                cardFormEmpty: empty
                                                            });
                                                        }
                                                        return (
                                                            <div>
                                                                <label style={{ display: 'block', marginBottom: '15px' }}>
                                                                    Card Details
                                                                </label>
                                                                <div style={{ display: 'block', marginBottom: '40px' }}>
                                                                    {renderCard()}
                                                                    { error && error.message && <p style={{ color: 'red', fontSize: 12, marginLeft: 30 }}>{error.message}</p>}
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                }
                                            />

                                            { this.props.errors && <ErrorMessage errors={this.props.errors} />}
                                            
                                            <ActionButton options={{
                                                label: `Finish & Pay`,
                                                form: null,
                                                primary: false,
                                                secondary: true,
                                                isNextButton: false,
                                                disabled: invalid || !this.state.selectedProvince || submitting || this.state.submitted || this.state.cardFormEmpty || !this.state.cardFormComplete || (this.state.cardFormError && this.state.cardFormError.message),
                                                action: (event)=>{
                                                    // PAYMENT
                                                    // console.log('EVENT', event);
                                                    handleSubmit(event);
                                                }
                                            }} />
                                            { !this.state.submitted && 
                                                <span>
                                                    <BackButton reverseStepper={this.props.reverseStepper} />
                                                    <CancelButton handleClose={this.props.handleClose} />
                                                </span>
                                            }
                                        </form>
                                        <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end', }}>
                                            <img src={photoURLs.stripeBadge} style={{ width: 150, padding: 30, paddingRight: 0, }}/>
                                        </div>
                                    </div>
                                );
                            }}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div style={ styles.paymentFormContainerStyles }>
                    { this.state.submitted &&
                        <ProgressSpinner 
                            loadingText="PROCESSING..." 
                            message="(You will be redirected shortly. Please do not leave or close this window.)" 
                        />
                    }
                    <div>
                        <Form
                            onSubmit={this.handleSubmit}
                            initialValues={null}
                            validate={ values => {
                                const errors = {};

                                if (!values.province) {
                                    errors.province = "Required";
                                }
                                return errors;
                                }
                            }
                            render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => {
                                return (
                                    <div>
                                        <form id="creditsOnlyPaymentForm" onSubmit={handleSubmit}>
                                            <FormGroup stack>
                                                <label> Province</label>
                                                <div style={{ width: '100%' }}>
                                                    <FormIcon name="user" color="#9e9e9e" size={16} />
                                                    <Field
                                                        render={({ input, meta }) => (
                                                            <div>
                                                                <SelectFieldAdapter 
                                                                    input={input}
                                                                    meta={meta}
                                                                    style={{ width: 135 }}
                                                                    name="province"
                                                                    options={taxByProvince}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </FormGroup>
    
                                            { this.props.errors && <ErrorMessage errors={this.props.errors} />}
                                            <p>Click "Finish & Pay" to apply your credits to this purchase.</p>
                                            <ActionButton 
                                                options = {{
                                                    label: `Finish & Pay`,
                                                    form: null,
                                                    primary: false,
                                                    secondary: true,
                                                    isNextButton: false,
                                                    disabled: !this.state.selectedProvince || this.state.submitted || submitting,
                                                    action: (event)=>{
                                                        this.handleCreditSubmit(event);
                                                    }
                                                }} 
                                            />
                                            { !this.state.submitted && <BackButton reverseStepper={this.props.reverseStepper} />}
                                            <CancelButton handleClose={this.props.handleClose} />
                                        </form>
                                    </div>
                                );
                            }}
                        />
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = ({auth, service, form, client, booking}) => {
    return {
        userId: (auth.authData) ? auth.authData.id : null,
        userData: client.clientData,
        service: service,
        formValues: form.formValues,
        selectedService: service.selectedService,
        booking: { 
            date: booking.details.date,
            time: booking.details.time,
            provider: booking.provider,
            service: booking.service,
        },
    }
};

const styles = {
        paymentFormContainerStyles: { 
        flex: 1, 
        display: 'flex', 
        height: '100%', 
        width: '100%', 
        flexDirection: 'column',
        fontSize: constants.text.baseFontStyles.fontSize,
    },
}

export const InjectedStripePaymentForm = withRouter(injectStripe(connect(mapStateToProps, actions)(StripePaymentForm)));




// WEBPACK FOOTER //
// ./src/js/components/Form/PaymentForms/StripePaymentForm.jsx